import { combineReducers } from 'redux'
import { fetchData } from './api'

const FETCH_DISCIPLINES_REQUEST = 'DISCIPLINES/FETCH_DISCIPLINES_REQUEST'
const FETCH_DISCIPLINES_SUCCESS = 'DISCIPLINES/FETCH_DISCIPLINES_SUCCESS'
const FETCH_DISCIPLINES_FAILURE = 'DISCIPLINES/FETCH_DISCIPLINES_FAILURE'

const disciplines = (state = {}, action) => {

    switch (action.type) {

        case FETCH_DISCIPLINES_SUCCESS:
            return action.response;

        default: 
            return state
    }  
}

const reducer = combineReducers({
    disciplines
})


export const fetchDisciplines = () => (dispatch) => {
    
    dispatch({type: FETCH_DISCIPLINES_REQUEST})

    return fetchData('wpapi/disciplines')
        .then(response => {
            dispatch({
                type: FETCH_DISCIPLINES_SUCCESS,
                response
            })
        })
        .catch(error => {
            dispatch({
                type: FETCH_DISCIPLINES_FAILURE,
                error
            })
        });      
}

export const getDisciplines = state => state.disciplines.disciplines

export default disciplines




// WEBPACK FOOTER //
// ./client/disciplines.js